import { render, staticRenderFns } from "./AboutInfoMain.vue?vue&type=template&id=8de53afc&scoped=true&"
import script from "./AboutInfoMain.vue?vue&type=script&lang=js&"
export * from "./AboutInfoMain.vue?vue&type=script&lang=js&"
import style0 from "./AboutInfoMain.vue?vue&type=style&index=0&id=8de53afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de53afc",
  null
  
)

export default component.exports